const cartDrawerModalObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (!(node instanceof HTMLElement)) return;

      if (node.matches?.('.tpo_modal-background.tpo_edit-option-modal')) {
        node.classList.add('tpo_cart_drawer_modal');
      }

      const modal = node.querySelector?.('.tpo_modal-background.tpo_edit-option-modal');
      if (modal) {
        modal.classList.add('tpo_cart_drawer_modal');
      }
    });
  });
});

cartDrawerModalObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

(function () {
  // Check if product belongs to "Livi Road Personalised & Engraved Bracelets" collection
  const collectionEl = document.querySelector('.easify_product_collections');
  if (!collectionEl) return;

  const collections = Array.from(collectionEl.querySelectorAll('p')).map(p => p.textContent.trim());
  if (!collections.includes('Livi Road Personalised & Engraved Bracelets')) return;

  // ── Main logic ──────────────────────────────────────────────────────────────
  let observer, timeoutId, configCheckInterval;

  function applyCustomizations() {
    const stickyWrapper = document.querySelector('.sticky-atc-bar__button');
    if (!stickyWrapper) return;

    const addToCartText = stickyWrapper.querySelector('.product-form__cart-submit [data-add-to-cart-text]');
    if (addToCartText?.textContent.trim() === 'Add to Cart') {
      addToCartText.textContent = 'Customise Me';
    }

    stickyWrapper.addEventListener('click', (e) => {
      if (!e.target.closest('.product-form__cart-submit')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      document.querySelector('.product__details .tpo-show-popup')?.click();
    }, true);
  }

  function cleanup() {
    observer?.disconnect();
    observer = null;
    clearTimeout(timeoutId);
    clearInterval(configCheckInterval);
  }

  function startObserving() {
    if (document.querySelector('.tpo_option-set-wrapper.tpo_has-option-set')) {
      return applyCustomizations();
    }

    observer = new MutationObserver(() => {
      if (document.querySelector('.tpo_option-set-wrapper.tpo_has-option-set')) {
        applyCustomizations();
        cleanup();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    timeoutId = setTimeout(cleanup, 5000);
  }

  if (document.querySelector('.tpo_option-set-wrapper.tpo_has-option-set')) {
    return applyCustomizations();
  }

  if (window.TPOConfigs) {
    startObserving();
  } else {
    configCheckInterval = setInterval(() => {
      if (window.TPOConfigs) {
        cleanup();
        startObserving();
      }
    }, 80);

    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => { if (!window.TPOConfigs) cleanup(); }, 5000);
    }, { once: true });
  }
})();

// Only show Easiy Options quick view in Livi Road Personalised & Engraved Bracelets collection
document.addEventListener('DOMContentLoaded', function() {
    if (!window.location.pathname.includes('/collections/')) return;

    const style = document.createElement('style');
    style.textContent = '.tpo_option-set-wrapper { display: none !important; }';

    const collections = document.querySelectorAll('.easify_custom_collections');

    collections.forEach(function(el) {
        if (el.textContent.trim() !== 'Livi Road Personalised & Engraved Bracelets') {
        document.head.appendChild(style);
        }
    });
});

(function () {
  'use strict';

  const LIMIT_GROUP_REGEX = /CustomLimit\(G(\d+),\s*(\d+)\)/;
  const LIMIT_LEGACY_REGEX = /CustomLimit\(\s*(\d+)\s*\)/;

  const SWATCH_INPUT_SELECTOR = '.tpo_image-swatches-input, .tpo_color-swatches-input';
  const WRAPPER_SELECTOR = [
    '.tpo_image-swatches-wrapper',
    '.tpo_swatches-label_position'
  ].join(', ');
  const TPO_CHECKED_CLASS = 'tpo_is_checked_swatches';
  const DISABLED_CLASS = 'tpo_swatch--limit-disabled';
  const QTY_WRAPPER_SELECTOR = '.tpo_quantity-selector_wrapper';
  const QTY_INPUT_SELECTOR = '.tpo_quantity-selector_input';
  const QTY_PLUS_SELECTOR = '.tpo_quantity-selector_plus';
  const QTY_UNAVAILABLE_CLASS = 'swatches-not-avaliable';
  const QTY_PLUS_DISABLED_CLASS = 'tpo-qty-plus--disabled';

  function debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  }

  if (!document.getElementById('tpo-custom-limit-style')) {
    const style = document.createElement('style');
    style.id = 'tpo-custom-limit-style';
    style.textContent = `
      .tpo_swatch--limit-disabled {
        opacity: 0.35;
        pointer-events: none;
        cursor: not-allowed;
      }
      .tpo-custom-limit-msg {
        display: block;
        color: #c0392b;
        font-size: 13px;
        margin-top: 8px;
      }
      .tpo-qty-plus--disabled {
        opacity: 0.35 !important;
        pointer-events: none !important;
        cursor: not-allowed !important;
      }
    `;
    document.head.appendChild(style);
  }

  function parseLimitInfo(input) {
    const str = (input.name || '') + ',' + (input.id || '');
    const groupMatch = str.match(LIMIT_GROUP_REGEX);
    if (groupMatch) return { group: `G${groupMatch[1]}`, limit: parseInt(groupMatch[2], 10) };
    const legacyMatch = str.match(LIMIT_LEGACY_REGEX);
    if (legacyMatch) return { group: 'default', limit: parseInt(legacyMatch[1], 10) };
    return null;
  }

  function hasCustomLimit(input) {
    return parseLimitInfo(input) !== null;
  }

  function buildGroupMap(optionSetContainer) {
    const groupMap = new Map();
    Array.from(optionSetContainer.querySelectorAll(WRAPPER_SELECTOR)).forEach((wrapper) => {
      const input = wrapper.querySelector(SWATCH_INPUT_SELECTOR);
      if (!input) return;
      const info = parseLimitInfo(input);
      if (!info) return;
      if (!groupMap.has(info.group)) groupMap.set(info.group, { limit: info.limit, wrappers: [] });
      groupMap.get(info.group).wrappers.push(wrapper);
    });
    return groupMap;
  }

  function getWrapperContribution(wrapper) {
    const isChecked = wrapper.querySelector(`label.${TPO_CHECKED_CLASS}`) !== null;
    const qtyWrapper = wrapper.querySelector(QTY_WRAPPER_SELECTOR);
    if (!qtyWrapper) return isChecked ? 1 : 0;
    if (qtyWrapper.classList.contains(QTY_UNAVAILABLE_CLASS)) return 0;
    const qtyInput = qtyWrapper.querySelector(QTY_INPUT_SELECTOR);
    return qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
  }

  function countGroupTotal(wrappers) {
    return wrappers.reduce((sum, w) => sum + getWrapperContribution(w), 0);
  }

  function updateQtyPlusState(wrapper, total, limit) {
    const qtyWrapper = wrapper.querySelector(QTY_WRAPPER_SELECTOR);
    if (!qtyWrapper || qtyWrapper.classList.contains(QTY_UNAVAILABLE_CLASS)) return;
    const plusBtn = qtyWrapper.querySelector(QTY_PLUS_SELECTOR);
    const qtyInput = qtyWrapper.querySelector(QTY_INPUT_SELECTOR);
    if (!plusBtn) return;

    if (total >= limit) {
      plusBtn.classList.add(QTY_PLUS_DISABLED_CLASS);
      if (qtyInput) qtyInput.dataset.maxReached = '1';
    } else {
      plusBtn.classList.remove(QTY_PLUS_DISABLED_CLASS);
      if (qtyInput) delete qtyInput.dataset.maxReached;
    }
  }

  function upsertLimitMessage(optionSetContainer, groupKey, wrappers, limit, total) {
    const firstWrapper = wrappers[0];
    const swatchesGroup = firstWrapper.closest('.tpo_option-type-image-swatches-wrapper');
    if (!swatchesGroup) return;

    const msgKey = `${optionSetContainer.id}__${groupKey}`;
    let msgEl = optionSetContainer.querySelector(`.tpo-custom-limit-msg[data-limit-msg="${msgKey}"]`);

    if (!msgEl) {
      msgEl = document.createElement('span');
      msgEl.className = 'tpo-custom-limit-msg';
      msgEl.dataset.limitMsg = msgKey;
      swatchesGroup.insertAdjacentElement('beforebegin', msgEl);
    }

    const remaining = limit - total;
    msgEl.textContent = remaining <= 0
      ? `You have reached the maximum selection of ${limit} item${limit !== 1 ? 's' : ''}.`
      : `You can select up to ${limit} item${limit !== 1 ? 's' : ''} (${remaining} remaining).`;
  }

  function enforceGroup(optionSetContainer, groupKey, groupData) {
    const { limit, wrappers } = groupData;
    const total = countGroupTotal(wrappers);

    wrappers.forEach((wrapper) => {
      const input = wrapper.querySelector(SWATCH_INPUT_SELECTOR);
      if (!input) return;

      const isActive = getWrapperContribution(wrapper) > 0;

      if (!isActive && total >= limit) {
        if (!wrapper.classList.contains(DISABLED_CLASS)) {
          wrapper.classList.add(DISABLED_CLASS);
        }
      } else {
        if (wrapper.classList.contains(DISABLED_CLASS)) {
          wrapper.classList.remove(DISABLED_CLASS);
        }
      }

      updateQtyPlusState(wrapper, total, limit);
    });

    upsertLimitMessage(optionSetContainer, groupKey, wrappers, limit, total);
  }

  function enforceAll(optionSetContainer) {
    const groupMap = buildGroupMap(optionSetContainer);
    groupMap.forEach((groupData, groupKey) => enforceGroup(optionSetContainer, groupKey, groupData));
  }

  // Bind events and observers once per wrapper.
  function bindWrapper(wrapper, optionSetContainer) {
    const input = wrapper.querySelector(SWATCH_INPUT_SELECTOR);
    if (!input) return;

    if (!input.dataset.customLimitBound) {
      input.dataset.customLimitBound = '1';
      input.addEventListener('change', () => {
        requestAnimationFrame(() => enforceAll(optionSetContainer));
      });
    }

    const label = wrapper.querySelector('label');
    if (label && !label.dataset.customLimitObserved) {
      label.dataset.customLimitObserved = '1';
      labelObserverFor(optionSetContainer).observe(label, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    const qtyWrapper = wrapper.querySelector(QTY_WRAPPER_SELECTOR);
    if (qtyWrapper) {
      if (!qtyWrapper.dataset.customLimitObserved) {
        qtyWrapper.dataset.customLimitObserved = '1';
        qtyObserverFor(optionSetContainer).observe(qtyWrapper, {
          attributes: true,
          attributeFilter: ['class'],
        });
      }

      const qtyInput = qtyWrapper.querySelector(QTY_INPUT_SELECTOR);
      if (qtyInput) {
        if (!qtyInput.dataset.customLimitObserved) {
          qtyInput.dataset.customLimitObserved = '1';
          qtyObserverFor(optionSetContainer).observe(qtyInput, {
            attributes: true,
            attributeFilter: ['value', 'data-previous-value'],
          });
        }

        if (!qtyInput.dataset.customLimitBound) {
          qtyInput.dataset.customLimitBound = '1';

          ['input', 'change', 'blur'].forEach((ev) => {
            qtyInput.addEventListener(ev, () => validateQtyInput(wrapper, optionSetContainer));
          });
        }
      }

      const plusBtn = qtyWrapper.querySelector(QTY_PLUS_SELECTOR);
      if (plusBtn && !plusBtn.dataset.customLimitBound) {
        plusBtn.dataset.customLimitBound = '1';
        plusBtn.addEventListener('click', (e) => {
          const currentGroupMap = buildGroupMap(optionSetContainer);
          for (const [, gData] of currentGroupMap) {
            if (gData.wrappers.includes(wrapper)) {
              const total = countGroupTotal(gData.wrappers);
              if (total >= gData.limit) {
                e.preventDefault();
                e.stopImmediatePropagation();
              }
              break;
            }
          }
        }, true);
      }
    }
  }

  // Allow manual quantity edits, but clamp them to the remaining allowed amount.
  function validateQtyInput(wrapper, optionSetContainer) {
    const qtyWrapper = wrapper.querySelector(QTY_WRAPPER_SELECTOR);
    if (!qtyWrapper || qtyWrapper.classList.contains(QTY_UNAVAILABLE_CLASS)) return;

    const qtyInput = qtyWrapper.querySelector(QTY_INPUT_SELECTOR);
    if (!qtyInput) return;

    const currentGroupMap = buildGroupMap(optionSetContainer);

    for (const [, gData] of currentGroupMap) {
      if (!gData.wrappers.includes(wrapper)) continue;

      const raw = parseInt(qtyInput.value, 10);
      const newQty = isNaN(raw) || raw < 0 ? 0 : raw;

      const currentContribution = getWrapperContribution(wrapper);
      const totalExcludingCurrent = countGroupTotal(gData.wrappers) - currentContribution;
      const maxAllowedForThisInput = Math.max(0, gData.limit - totalExcludingCurrent);

      if (newQty > maxAllowedForThisInput) {
        qtyInput.value = maxAllowedForThisInput;
      } else {
        qtyInput.value = newQty;
      }

      requestAnimationFrame(() => enforceAll(optionSetContainer));
      break;
    }
  }

  // Each option set gets its own observers.
  const observerCache = new WeakMap();

  function getObservers(optionSetContainer) {
    if (!observerCache.has(optionSetContainer)) {
      const debouncedEnforce = debounce(() => {
        enforceAll(optionSetContainer);
      }, 50);

      observerCache.set(optionSetContainer, {
        label: new MutationObserver(debouncedEnforce),
        qty: new MutationObserver(debouncedEnforce),
      });
    }
    return observerCache.get(optionSetContainer);
  }

  function labelObserverFor(optionSetContainer) {
    return getObservers(optionSetContainer).label;
  }

  function qtyObserverFor(optionSetContainer) {
    return getObservers(optionSetContainer).qty;
  }

  // Watch for wrappers rendered later by TPO conditional logic.
  const domWatcherCache = new WeakMap();

  function watchForNewWrappers(optionSetContainer) {
    if (domWatcherCache.has(optionSetContainer)) return;

    const debouncedScan = debounce(() => {
      let foundNew = false;

      optionSetContainer.querySelectorAll(WRAPPER_SELECTOR).forEach((wrapper) => {
        const input = wrapper.querySelector(SWATCH_INPUT_SELECTOR);
        if (!input || !hasCustomLimit(input)) return;

        if (!input.dataset.customLimitBound) {
          bindWrapper(wrapper, optionSetContainer);
          foundNew = true;
        }
      });

      if (foundNew) {
        enforceAll(optionSetContainer);
      }
    }, 150);

    const domWatcher = new MutationObserver((mutations) => {
      const hasAddedNodes = mutations.some((m) => m.addedNodes.length > 0);
      if (!hasAddedNodes) return;
      debouncedScan();
    });

    domWatcher.observe(optionSetContainer, {
      childList: true,
      subtree: true,
    });

    domWatcherCache.set(optionSetContainer, domWatcher);
  }

  function bindAllCurrentWrappers(optionSetContainer) {
    optionSetContainer.querySelectorAll(WRAPPER_SELECTOR).forEach((wrapper) => {
      const input = wrapper.querySelector(SWATCH_INPUT_SELECTOR);
      if (!input || !hasCustomLimit(input)) return;
      bindWrapper(wrapper, optionSetContainer);
    });
  }

  function init(root = document) {
    root.querySelectorAll('.tpo_option-set-container').forEach((optionSetContainer) => {
      if (optionSetContainer.dataset.customLimitInit === '1') {
        return;
      }
      optionSetContainer.dataset.customLimitInit = '1';

      bindAllCurrentWrappers(optionSetContainer);

      const groupMap = buildGroupMap(optionSetContainer);
      if (groupMap.size > 0) {
        enforceAll(optionSetContainer);
      }

      watchForNewWrappers(optionSetContainer);
    });
  }

  document.addEventListener('tpo_loaded', () => {
    requestAnimationFrame(() => init());
  });

  // Reinitialize when TPO modal content is reopened.
  const modalObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const modal = mutation.target;
      if (modal.style.display !== 'none') {
        modal.querySelectorAll('.tpo_option-set-container[data-custom-limit-init]').forEach((el) => {
          delete el.dataset.customLimitInit;
          const oldWatcher = domWatcherCache.get(el);
          if (oldWatcher) {
            oldWatcher.disconnect();
            domWatcherCache.delete(el);
          }
        });
        modal.querySelectorAll('.tpo-custom-limit-msg').forEach((el) => el.remove());
        requestAnimationFrame(() => init(modal));
      }
    });
  });

  function observeModals() {
    document.querySelectorAll('.tpo_modal-background').forEach((modal) => {
      if (modal.dataset.customLimitObserved === '1') return;
      modal.dataset.customLimitObserved = '1';
      modalObserver.observe(modal, { attributes: true, attributeFilter: ['style', 'class'] });
    });
  }

  const customLimitDomObserver = new MutationObserver(observeModals);
  customLimitDomObserver.observe(document.body, { childList: true, subtree: true });
  observeModals();
})();

(function () {
  'use strict';

  const EXCLUSIVE_GROUP_REGEX = /CustomExclusive\((\d+)\)/;
  const SWATCH_INPUT_SELECTOR = '.tpo_image-swatches-input, .tpo_color-swatches-input';
  const TPO_CHECKED_CLASS = 'tpo_is_checked_swatches';
  const CONTAINER_DISABLED_CLASS = 'tpo-exclusive--container-disabled';

  // ─── STYLE ───────────────────────────────────────────────────────────────────
  if (!document.getElementById('tpo-custom-exclusive-style')) {
    const style = document.createElement('style');
    style.id = 'tpo-custom-exclusive-style';
    style.textContent = `
      .tpo-exclusive--container-disabled {
        opacity: 0.35;
        pointer-events: none;
        cursor: not-allowed;
        user-select: none;
      }
    `;
    document.head.appendChild(style);
    console.log('[DEBUG] CustomExclusive | Style injected');
  }

  // ─── HELPERS ─────────────────────────────────────────────────────────────────
  function debounce(fn, delay) {
    let timer;
    return (...args) => { clearTimeout(timer); timer = setTimeout(() => fn(...args), delay); };
  }

  function getExclusiveGroup(input) {
    const str = `${input.name || ''},${input.id || ''}`;
    const match = str.match(EXCLUSIVE_GROUP_REGEX);
    return match ? match[1] : null;
  }

  function hasCustomExclusive(input) {
    return getExclusiveGroup(input) !== null;
  }

  function containerHasActiveSelection(container) {
    return container.querySelector(`label.${TPO_CHECKED_CLASS}`) !== null;
  }

  function getContainerGroup(container) {
    const input = container.querySelector(SWATCH_INPUT_SELECTOR);
    return input ? getExclusiveGroup(input) : null;
  }

  // ─── BUILD GROUP MAP: Map<groupId, container[]> ───────────────────────────────
  function getExclusiveContainersByGroup(optionSetContainer) {
    const groupMap = new Map();
    optionSetContainer.querySelectorAll('.tpo_option-container').forEach((container) => {
      const input = container.querySelector(SWATCH_INPUT_SELECTOR);
      if (!input) return;
      const group = getExclusiveGroup(input);
      if (!group) return;
      if (!groupMap.has(group)) groupMap.set(group, []);
      groupMap.get(group).push(container);
    });
    return groupMap;
  }

  // ─── ENFORCE: disable sibling containers, enable active ──────────────────────
  function enforceExclusiveGroup(groupId, containers) {
    const activeContainer = containers.find(containerHasActiveSelection) || null;

    console.log(`[DEBUG] CustomExclusive | enforceGroup | group="${groupId}" | active="${activeContainer?.id.slice(-30) || 'NONE'}"`);
    containers.forEach((c) => {
        console.log(
        `  [DEBUG] container="${c.id.slice(-30)}" | hasActive=${containerHasActiveSelection(c)} | isDisabled=${c.classList.contains(CONTAINER_DISABLED_CLASS)}`
        );
    });

    containers.forEach((container) => {
        const shouldDisable = activeContainer !== null && container !== activeContainer;
        if (shouldDisable) {
        if (!container.classList.contains(CONTAINER_DISABLED_CLASS)) {
            container.classList.add(CONTAINER_DISABLED_CLASS);
            console.log(`  [DEBUG] → DISABLED "${container.id.slice(-30)}"`);
        }
        } else {
        if (container.classList.contains(CONTAINER_DISABLED_CLASS)) {
            container.classList.remove(CONTAINER_DISABLED_CLASS);
            console.log(`  [DEBUG] → ENABLED "${container.id.slice(-30)}"`);
        }
        }
    });
    }

  function enforceAll(optionSetContainer) {
    const groupMap = getExclusiveContainersByGroup(optionSetContainer);
    groupMap.forEach((containers, groupId) => enforceExclusiveGroup(groupId, containers));
  }

  // ─── INTERCEPT FORM SUBMIT: clear hidden fields của disabled containers ───────
  // Đảm bảo data của container bị disable không được submit vào cart
  function bindFormSubmitIntercept(optionSetContainer) {
    // Lấy form id từ hidden-checkbox bên trong
    const sampleHidden = optionSetContainer.querySelector('.tpo_hidden-checkbox[form]');
    if (!sampleHidden) return;

    const formId = sampleHidden.getAttribute('form');
    const form = formId ? document.getElementById(formId) : sampleHidden.closest('form');
    if (!form || form.dataset.customExclusiveSubmitBound === '1') return;

    form.dataset.customExclusiveSubmitBound = '1';

    form.addEventListener('submit', (e) => {
      const disabledContainers = optionSetContainer.querySelectorAll(
        `.tpo_option-container.${CONTAINER_DISABLED_CLASS}`
      );

      if (!disabledContainers.length) return;

      disabledContainers.forEach((container) => {
        const hiddenFields = container.querySelectorAll('.tpo_hidden-checkbox');
        hiddenFields.forEach((field) => {
          if (field.value || field.checked) {
            console.log(
              `[DEBUG] CustomExclusive | submit intercept | clearing field="${field.name}" value="${field.value}"`
            );
            field.value = '';
            field.checked = false;
            field.removeAttribute('checked');
          }
        });
      });
    }, true); // capture phase — chạy trước TPO submit handler

    console.log(`[DEBUG] CustomExclusive | Submit intercept bound | form="${formId}"`);
  }

  // ─── OBSERVERS ───────────────────────────────────────────────────────────────
  const observerCache = new WeakMap();
  const domWatcherCache = new WeakMap();

  function getObservers(optionSetContainer) {
    if (!observerCache.has(optionSetContainer)) {
      const debouncedEnforce = debounce(() => {
        console.log('[DEBUG] CustomExclusive | label mutation → re-enforce');
        enforceAll(optionSetContainer);
      }, 40);

      observerCache.set(optionSetContainer, {
        labelObserver: new MutationObserver((mutations) => {
        // Bắt CẢ HAI chiều: add và remove tpo_is_checked_swatches
        const hasRelevant = mutations.some((m) => {
            if (!(m.target instanceof Element)) return false;
            const wasChecked = m.oldValue?.includes(TPO_CHECKED_CLASS);
            const isChecked = m.target.classList.contains(TPO_CHECKED_CLASS);
            // checked→unchecked HOẶC unchecked→checked đều cần re-evaluate
            return wasChecked !== isChecked;
        });

        if (hasRelevant) {
            console.log('[DEBUG] CustomExclusive | label mutation → re-enforce');
            debouncedEnforce();
        }
        }),
      });
    }
    return observerCache.get(optionSetContainer);
  }

  // ─── BIND ────────────────────────────────────────────────────────────────────
  function bindContainer(container, optionSetContainer) {
    const inputs = container.querySelectorAll(SWATCH_INPUT_SELECTOR);
    if (!inputs.length) return;
    if (!getContainerGroup(container)) return;

    inputs.forEach((input) => {
      if (input.dataset.customExclusiveBound === '1') return;
      input.dataset.customExclusiveBound = '1';

      input.addEventListener('change', () => {
        console.log(`[DEBUG] CustomExclusive | input change | value="${input.value}"`);
        requestAnimationFrame(() => enforceAll(optionSetContainer));
      });
    });

    container.querySelectorAll('label').forEach((label) => {
      if (label.dataset.customExclusiveObserved === '1') return;
      label.dataset.customExclusiveObserved = '1';
      getObservers(optionSetContainer).labelObserver.observe(label, {
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true,
      });
    });
  }

  function bindAllCurrentContainers(optionSetContainer) {
    const groupMap = getExclusiveContainersByGroup(optionSetContainer);
    if (groupMap.size === 0) return;
    optionSetContainer.querySelectorAll('.tpo_option-container').forEach((container) => {
      bindContainer(container, optionSetContainer);
    });
  }

  // ─── DOM WATCHER: bắt container inject muộn ───────────────────────────────────
  function watchForNewContainers(optionSetContainer) {
    if (domWatcherCache.has(optionSetContainer)) return;

    const debouncedScan = debounce(() => {
      let found = false;
      optionSetContainer.querySelectorAll('.tpo_option-container').forEach((container) => {
        const input = container.querySelector(SWATCH_INPUT_SELECTOR);
        if (!input || !hasCustomExclusive(input)) return;
        if (!container.querySelector('[data-custom-exclusive-bound="1"]')) {
          bindContainer(container, optionSetContainer);
          found = true;
        }
      });
      if (found) {
        console.log('[DEBUG] CustomExclusive | New containers found → enforceAll');
        enforceAll(optionSetContainer);
      }
    }, 120);

    const domWatcher = new MutationObserver((mutations) => {
      if (mutations.some((m) => m.addedNodes.length > 0)) debouncedScan();
    });

    domWatcher.observe(optionSetContainer, { childList: true, subtree: true });
    domWatcherCache.set(optionSetContainer, domWatcher);
    console.log(`[DEBUG] CustomExclusive | DOM watcher started | container="${optionSetContainer.id}"`);
  }

  // ─── CLEANUP ─────────────────────────────────────────────────────────────────
  function cleanupOptionSet(optionSetContainer) {
    delete optionSetContainer.dataset.customExclusiveInit;

    const observers = observerCache.get(optionSetContainer);
    if (observers?.labelObserver) observers.labelObserver.disconnect();
    observerCache.delete(optionSetContainer);

    const domWatcher = domWatcherCache.get(optionSetContainer);
    if (domWatcher) domWatcher.disconnect();
    domWatcherCache.delete(optionSetContainer);

    // Remove disabled class khi cleanup
    optionSetContainer.querySelectorAll(`.${CONTAINER_DISABLED_CLASS}`).forEach((el) => {
      el.classList.remove(CONTAINER_DISABLED_CLASS);
    });
  }

  // ─── INIT ────────────────────────────────────────────────────────────────────
  function init(root = document) {
    console.log('[DEBUG] CustomExclusive | init() on', root === document ? 'document' : root.className);

    root.querySelectorAll('.tpo_option-set-container').forEach((optionSetContainer) => {
      if (optionSetContainer.dataset.customExclusiveInit === '1') return;
      optionSetContainer.dataset.customExclusiveInit = '1';

      bindAllCurrentContainers(optionSetContainer);
      bindFormSubmitIntercept(optionSetContainer);
      enforceAll(optionSetContainer);
      watchForNewContainers(optionSetContainer);
    });
  }

  document.addEventListener('tpo_loaded', () => {
    console.log('[DEBUG] CustomExclusive | tpo_loaded fired');
    requestAnimationFrame(() => init());
  });

  // ─── MODAL OBSERVER ──────────────────────────────────────────────────────────
  const modalObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const modal = mutation.target;
      if (!(modal instanceof Element)) return;
      if (modal.style.display !== 'none') {
        modal.querySelectorAll('.tpo_option-set-container[data-custom-exclusive-init]').forEach((el) => {
          cleanupOptionSet(el);
        });
        requestAnimationFrame(() => init(modal));
      }
    });
  });

  function observeModals() {
    document.querySelectorAll('.tpo_modal-background').forEach((modal) => {
      if (modal.dataset.customExclusiveObserved === '1') return;
      modal.dataset.customExclusiveObserved = '1';
      modalObserver.observe(modal, { attributes: true, attributeFilter: ['style', 'class'] });
    });
  }

  const customExclusiveDomObserver = new MutationObserver(observeModals);
  customExclusiveDomObserver.observe(document.body, { childList: true, subtree: true });
  observeModals();

    let tpoLoadedFired = false;
        document.addEventListener('tpo_loaded', () => { tpoLoadedFired = true; }, { once: true });
        setTimeout(() => {
        if (!tpoLoadedFired) {
            console.log('[DEBUG] CustomExclusive | tpo_loaded missed → fallback init');
            init();
        }
    }, 3000);
})();

window.addEventListener('load', () => {
    const isMobile = window.innerWidth <= 768;

    const selector = isMobile
        ? '.product__media-container.below-mobile .product__media-item.swiper-slide-duplicate-active'
        : '.product__media-container.above-mobile .product__media';

    const el = document.querySelector(selector);

    if (el) {
        el.classList.add('easify-custom-live-preview-parent');
        console.log(`Class added for: ${isMobile ? 'Mobile' : 'Desktop'}`);
    } else {
        console.log('No class found');
    }
});